// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetIsEditable = () => getClaimDefaultState().isEditable;

const setClaimMode = (state, action) => action.isEditable;

export default (state = getClaimDefaultState().isEditable, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_TRACK_IS_EDITABLE]: setClaimMode,
        [actions.COPY_CLAIM_TRACK]: resetIsEditable,
        [actions.ADD_CLAIM_TRACK_ADDITIONAL_REPAIR]: resetIsEditable,
        [actions.RESET_CLAIM_TRACK]: resetIsEditable
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/track/reducers/is-editable.js